import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { LoginComponent } from './login.component';

import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/components/shared.module';
import { CreateAccountComponent } from 'app/views/user/createAccount.component';
import { EmailActionHandlerComponent } from 'app/views/user/emailActionHandler.component';
import { ForgotPasswordComponent } from 'app/views/user/forgotPassword.component';
import { VerifyEmailComponent } from 'app/views/user/verifyEmail.component';

@NgModule({
  declarations: [
    LoginComponent,
    CreateAccountComponent,
    EmailActionHandlerComponent,
    ForgotPasswordComponent,
    VerifyEmailComponent
  ],
  imports: [
    BrowserModule,
    RouterModule,
    SharedModule,
    TranslateModule,
    FormsModule
  ],
  exports: [
    LoginComponent
  ]
})

export class UserViewsModule { }



// WEBPACK FOOTER //
// ./src/app/views/user/userViews.module.ts